import { Box } from '@chakra-ui/react';

import { Condition } from 'Component/others';
import Breadcrumb from 'UiKit/breadcrumb';
import { TextBold, TextRegular } from 'UiKit/typography';

import { HeadSkeleton } from 'View/report-attendance/component/skeleton';

import styles from './styles.module.css';

const Head = ({ isFetching, data, t }) => {
  const breadcrumbItems = [
    {
      title: t('header.breadcrumb1'),
      href: '/report/attendance?tab=host',
    },
    {
      title: data?.hostName,
    },
  ];

  return (
    <Box className={styles['head__container']}>
      <Condition statement={!isFetching} fallback={<HeadSkeleton />}>
        <Breadcrumb items={breadcrumbItems} />
        <TextBold className={styles['head__text--host-name']}>{data?.hostName}</TextBold>
        <TextRegular className={styles['head__text--brand']}>{data?.brandName}</TextRegular>
      </Condition>
    </Box>
  );
};

export default Head;
